import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {GenericDocApprovalRequestContainerModel} from '../../../../../../models/aggregates/erp/generic-approval';
import { Pagination } from '../../shared/pagination.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class GenericDocApprovalRequestService extends BaseApiTemplateService<GenericDocApprovalRequestContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/approval-requests/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/approval-requests/backoffice-ep';
    this.httpClient = http;
  }

  getByCriteriaLoginEntityPrimaryEp(
      loginSubjectGuid: any,
      // pagination: Pagination,
      visa: ApiVisa,
      criteria?: any,
    ): Observable<PagingResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
        customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/approval-requests/login-entity-primary-ep/' + loginSubjectGuid;
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      // const UrlByCriteria =
      //   customUrl + '/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<any>>(
        customUrl,
        this.getHttpHeader(visa)
      );
    }


    approve(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      let customUrl;
      if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
          customUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/approvals/approval-requests/processors/login-entity-primary-ep';
      }
      return this.httpClient.put<ApiResponseModel<any>>(
        customUrl,
        dtoObject,
        this.getHttpHeader(visa)
      );
    }

}
